export { default as CompleteSignupStateless } from './complete-signup-stateless';
